import { render, staticRenderFns } from "./dependent.vue?vue&type=template&id=21a1880d&scoped=true"
import script from "./dependent.vue?vue&type=script&lang=js"
export * from "./dependent.vue?vue&type=script&lang=js"
import style0 from "./dependent.vue?vue&type=style&index=0&id=21a1880d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1880d",
  null
  
)

export default component.exports